import {
  SettingsViewContent,
  SettingsViewState,
} from '../../client/appTypings';
import {
  replaceSettingsViewDataAction,
  updateSettingsViewDataAction,
} from './actions';
import { createReducer } from '@reduxjs/toolkit';

const initialSettingsViewState: SettingsViewState = [];

export const settingsViewReducer = createReducer(
  initialSettingsViewState,
  builder =>
    builder
      .addCase(replaceSettingsViewDataAction, (state, action) => {
        return action.payload.data;
      })
      .addCase(updateSettingsViewDataAction, (state, action) => {
        const {
          payload: { htmlDocument, tabIndex, type },
        } = action;

        if (htmlDocument) {
          const update: SettingsViewContent[] = state.slice();

          update[tabIndex] = {
            htmlDocument,
            title: state[tabIndex]?.title || '',
            type,
          };

          return update;
        }
      })
);
